<template>
  <div class="nutrient-removal-yield">
    <div class="nutrient-removal-yield__value">
      <AppHeading size="xl" theme="black" class="crop-value">
        {{ formattedValue }}
        <small class="crop-unit">{{ crop.yield.unit }}</small>
      </AppHeading>
    </div>

    <div class="nutrient-removal-yield__slider">
      <VueSlider
        v-model="value"
        :dotSize="24"
        :interval="interval"
        :height="2"
        :marks="[crop.yield.min, crop.yield.max]"
        :min="crop.yield.min"
        :max="crop.yield.max"
        :silent="true"
        tooltip="none"
      />
    </div>

    <AppParagraph size="sm" spacing="xs" theme="gray" class="yield-copy">
      N, P<sub>2</sub>O<sub>5</sub>, K<sub>2</sub>O, and S removal
      coefficients derived from the IPNI Nutrient Removal Calculator as of Jan.
      2018 (http://www.ipni.net/article/IPNI-3346). Mg removal coefficients
      derived from Alabama Extension: ANR-449 (1999), CFI (2001), IPNI (2008),
      North Carolina: AG-439-16 (1991) and other independent sources.
    </AppParagraph>
    <AppParagraph size="sm" theme="gray" class="yield-copy">
      <br /><br />
      *Nutrient removal values may vary regionally depending on growing
      conditions. Use locally available data whenever possible. Crop nutrient
      removal and soil test considerations should be made for proper nutrient
      recommendations.
    </AppParagraph>
  </div>
</template>

<script>
import AppHeading from '@/components/shared/AppHeading';
import VueSlider from 'vue-3-slider-component'

export default {
  components: {
    AppHeading,
    VueSlider
  },
  props: {
    crop: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      value: 0
    };
  },
  computed: {
    formattedValue() {
      const decimalPlaces = this.interval < 1 ? 1 : 0;

      return this.value.toFixed(decimalPlaces);
    },
    interval() {
      const { min, max } = this.crop.yield;

      return (max - min) / 12;
    },
    percentage() {
      const { min, max } = this.crop.yield;

      return (this.value - min) / (max - min);
    }
  },
  watch: {
    crop(crop) {
      const { min, max } = crop.yield;
      this.value = (max - min) / 4 + min;
      this.$emit('change', { percentage: this.percentage, value: this.value });
    },
    value(value) {
      this.$emit('change', { percentage: this.percentage, value });
    }
  },
  beforeMount() {
    if (!this.value) {
      const { min, max } = this.crop.yield;
      this.value = (max - min) / 4 + min;
      this.$emit('change', { percentage: this.percentage, value: this.value });
    }
  }
};
</script>

<style lang="scss" scoped>
.nutrient-removal-yield {
  margin: spacing('lg') 0;

  @include breakpoint('md') {
    margin-bottom: 0;
    width: 28rem;
  }

  &__value small {
    font-size: 30%;
  }

  &__slider { // this was wrapped in deep
    margin-bottom: spacing('lg', 2);

    :deep(.vue-slider-rail) {
      background-color: shade('white', 10%);
    }

    :deep(.vue-slider-process) {
      background-color: var(--color-hearty-green);
      border-radius: 0;
    }

    :deep(.vue-slider-dot-handle) {
      background-color: var(--color-hearty-green);
      border: solid 2px var(--color-hearty-green);
      box-shadow: none;
    }

    :deep(.vue-slider-mark-label) {
      font-family: $articulat-cf;
      font-size: 20px;
      
      @include breakpoint('md') {
        font-size: 24px;
      }
    }
  }
  .crop-value {
      font-size: 100px;
      font-family: $articulat-cf;
      font-weight: 900;
      line-height: 102px;

      @include breakpoint('md') {
        font-size: 180px;
        font-weight: 900;
        line-height: 184px;
      }
  }
  .crop-unit {
    font-size: 24px;
    font-family: $articulat-cf;
    font-weight: 400;
    line-height: 41px;
    
    @include breakpoint('md') {
      font-size: 24px;
      font-weight: 400;
      line-height: 41px;
    }
  }
  .yield-copy {
    color: rgb(124 124 124 / 60%);
    font-size: 14px;
    font-family: $inter;
    font-weight: 400;
    line-height: 20px;
    text-align: center;

    @media (max-width: 320px) {
      display: none;      
    }
  }
}
</style>
